module.exports = __webpack_public_path__ + "assets/img/vtuber-3d.66c08f2c.png";